import script from "./pressDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./pressDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./pressDetailPage.vue?vue&type=style&index=0&id=334902ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334902ab"]])

export default __exports__